(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      if (!this.track) return;

      const realSlides = Array.from(this.track.querySelectorAll('[data-real-slide]'));
      if (realSlides.length < 2) return;

      const firstClone = realSlides[0].cloneNode(true);
      const lastClone = realSlides[realSlides.length - 1].cloneNode(true);
      [firstClone, lastClone].forEach((clone) => {
        clone.removeAttribute('data-real-slide');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.setAttribute('tabindex', '-1');
        clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      });

      const leadingSentinel = this.track.firstElementChild;
      const trailingSentinel = this.track.lastElementChild;
      this.track.insertBefore(lastClone, leadingSentinel.nextSibling);
      this.track.insertBefore(firstClone, trailingSentinel);

      this.slides = Array.from(this.track.querySelectorAll('[data-slideshow-slide]'));
      this.lastIndex = this.slides.length - 1;
      this.firstRealIndex = 1;
      this.lastRealIndex = this.lastIndex - 1;

      this.jumpTo(this.firstRealIndex, false);
      window.addEventListener('resize', () => this.jumpTo(this.getCenterIndex(), false));

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.advance(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.advance(1));

      let scrollEndTimer;
      this.track.addEventListener('scroll', () => {
        if (this.suppressScrollEnd) return;
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(() => this.handleScrollEnd(), 120);
      });

      if (this.dataset.autoplay === 'true') {
        const speed = (parseFloat(this.dataset.speed) || 5) * 1000;
        this.autoplayInterval = setInterval(() => this.advance(1), speed);
        this.addEventListener('mouseenter', () => clearInterval(this.autoplayInterval));
        this.addEventListener('mouseleave', () => {
          this.autoplayInterval = setInterval(() => this.advance(1), speed);
        });
      }
    }

    centerOffset(slide) {
      return slide.offsetLeft + slide.clientWidth / 2 - this.track.clientWidth / 2;
    }

    getCenterIndex() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let closest = this.firstRealIndex;
      let minDist = Infinity;
      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - center);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    jumpTo(idx, smooth = true) {
      const slide = this.slides[idx];
      if (!slide) return;
      const target = this.centerOffset(slide);
      if (smooth) {
        this.track.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        this.suppressScrollEnd = true;
        const prev = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = target;
        this.track.style.scrollBehavior = prev;
        requestAnimationFrame(() => {
          this.suppressScrollEnd = false;
        });
      }
    }

    advance(dir) {
      const idx = this.getCenterIndex();
      this.jumpTo(idx + dir, true);
    }

    handleScrollEnd() {
      const idx = this.getCenterIndex();
      if (idx === 0) {
        this.jumpTo(this.lastRealIndex, false);
      } else if (idx === this.lastIndex) {
        this.jumpTo(this.firstRealIndex, false);
      }
    }
  }

  if (!customElements.get('announcement-bar-slider')) {
    customElements.define('announcement-bar-slider', AnnouncementBarSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-categories"] && !Shopify.designMode) return;
  try {
    
  class CollectionCategories extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('[data-collection-description]');
      if (!this.details) return;
      const summary = this.details.querySelector('summary');
      if (!summary) return;
      requestAnimationFrame(() => {
        const clamp = summary.querySelector('span p') || summary.querySelector('span');
        if (!clamp) return;
        if (clamp.scrollHeight <= clamp.clientHeight + 1) {
          this.details.removeAttribute('open');
          this.details.classList.add('pointer-events-none');
          const toggle = summary.querySelector('span:last-child');
          if (toggle) toggle.classList.add('hidden');
          summary.style.cursor = 'default';
        }
      });
    }
  }
  customElements.define('collection-categories', CollectionCategories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filter-cards"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilterCards extends HTMLElement {
    connectedCallback() {
      // Selecting a card applies (or removes) the matching Shopify facet by
      // navigating to the URL Liquid pre-built from the filter value — the same
      // thing the native filter form does. No hidden-input mirroring.
      this.querySelectorAll('[data-filter-card]').forEach((card) => {
        const url = card.dataset.nav;
        if (!url) return;
        const checkbox = card.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.addEventListener('change', (e) => {
            e.preventDefault();
            window.location.href = url;
          });
        }
      });

      // Mobile dropdown open/close.
      this.dropdown = this.querySelector('[data-dropdown]');
      const toggle = this.querySelector('[data-dropdown-toggle]');
      const panel = this.querySelector('[data-dropdown-panel]');
      if (toggle && panel) {
        toggle.addEventListener('click', () => {
          const open = panel.classList.toggle('hidden');
          toggle.setAttribute('aria-expanded', String(!open));
          toggle.querySelector('svg')?.classList.toggle('rotate-180', !open);
        });
        document.addEventListener('click', (e) => {
          if (this.dropdown.contains(e.target) || panel.classList.contains('hidden')) return;
          panel.classList.add('hidden');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.querySelector('svg')?.classList.remove('rotate-180');
        });
      }

      // Desktop slider pagination.
      this.scroller = this.querySelector('[data-scroller]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      if (this.scroller && (this.prevBtn || this.nextBtn)) {
        this.prevBtn?.addEventListener('click', () => this.scroll(-1));
        this.nextBtn?.addEventListener('click', () => this.scroll(1));
        this.scroller.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons());
        this.updateButtons();
      }
    }

    scroll(direction) {
      if (!this.scroller) return;
      const card = this.scroller.querySelector('[data-filter-card]');
      const gap = parseFloat(getComputedStyle(this.scroller.firstElementChild).columnGap) || 16;
      const step = card ? card.getBoundingClientRect().width + gap : this.scroller.clientWidth * 0.8;
      this.scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.scroller) return;
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const buttons = this.querySelector('[data-slider-buttons]');
      // Hide the controls entirely when everything fits (inline style overrides
      // the lg:flex class cleanly; '' restores class-driven display).
      if (buttons) buttons.style.display = max <= 1 ? 'none' : '';
      if (this.prevBtn) this.prevBtn.disabled = this.scroller.scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = this.scroller.scrollLeft >= max - 1;
    }
  }
  customElements.define('collection-filter-cards', CollectionFilterCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-drawer"] && !Shopify.designMode) return;
  try {
    
  (function setupCompareDrawer() {
    const root = document.querySelector('compare-drawer');
    if (!root) return;

    const panel = root.querySelector('[data-compare-panel]');
    const grid = root.querySelector('[data-compare-grid]');
    const countEl = root.querySelector('[data-compare-count]');
    const collapseBtn = root.querySelector('[data-compare-collapse]');
    const chevron = root.querySelector('[data-compare-chevron]');
    const clearCloseBtn = root.querySelector('[data-compare-clear-close]');
    const bodyEl = root.querySelector('[data-compare-body]');
    const config = JSON.parse(root.querySelector('[data-compare-config]').textContent);

    const MAX = parseInt(root.dataset.max, 10) || 4;
    const STORE_KEY = 'kukoon:compare';
    const COLLAPSE_KEY = 'kukoon:compare:collapsed';
    const fetchCache = {};

    const checkSvg =
      '<svg viewBox="0 0 19 19" width="17" height="17" class="shrink-0" aria-hidden="true">' +
      '<path d="M15.142,9.983,10.875,14.25,9.42,12.8M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Z" transform="translate(-2.5 -2.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></svg>';
    const closeSvg =
      '<svg viewBox="0 0 18 17" width="11" height="11" fill="none" aria-hidden="true">' +
      '<path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>';
    const plusSvg =
      '<svg viewBox="0 0 10 10" width="16" height="16" fill="none" aria-hidden="true">' +
      '<path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>';

    /* ---- store ---- */
    // Stored items carry a formatted `price` string (e.g. "£129.00") captured at the
    // time they were added. Those are stale the moment the shopper switches market,
    // so the stored currency is stamped and mismatched entries are dropped rather
    // than replayed as GBP prices inside a EUR market.
    const CURRENCY_KEY = STORE_KEY + ':currency';
    const activeCurrency = () =>
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

    const read = () => {
      try {
        const stored = localStorage.getItem(CURRENCY_KEY);
        const current = activeCurrency();
        if (stored && current && stored !== current) {
          localStorage.removeItem(STORE_KEY);
          localStorage.setItem(CURRENCY_KEY, current);
          return [];
        }
        return JSON.parse(localStorage.getItem(STORE_KEY)) || [];
      } catch (e) { return []; }
    };
    const write = (items) => {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify(items));
        const current = activeCurrency();
        if (current) localStorage.setItem(CURRENCY_KEY, current);
      } catch (e) {}
    };

    /* ---- visibility ---- */
    let hideTimer = null;
    const show = () => {
      window.clearTimeout(hideTimer);
      root.classList.remove('hidden');
      requestAnimationFrame(() => { panel.dataset.active = ''; });
    };
    const hide = () => {
      delete panel.dataset.active;
      hideTimer = window.setTimeout(() => { root.classList.add('hidden'); }, 300);
    };

    /* ---- collapse ---- */
    const applyCollapsed = (collapsed) => {
      collapseBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      if (collapsed) {
        chevron.dataset.collapsed = '';
        if (clearCloseBtn) clearCloseBtn.dataset.collapsed = '';
        bodyEl.style.maxHeight = '0px';
      } else {
        delete chevron.dataset.collapsed;
        if (clearCloseBtn) delete clearCloseBtn.dataset.collapsed;
        bodyEl.style.maxHeight = bodyEl.scrollHeight + 'px';
      }
    };
    const isCollapsed = () => localStorage.getItem(COLLAPSE_KEY) === '1';
    collapseBtn.addEventListener('click', () => {
      const next = !isCollapsed();
      localStorage.setItem(COLLAPSE_KEY, next ? '1' : '0');
      applyCollapsed(next);
    });

    /* ---- product data (lazy) ---- */
    // Market-prefixed: the unprefixed /products/<handle>.js returns the DEFAULT
    // market's prices, so an EUR shopper was comparing GBP amounts labelled "€".
    const rootUrl = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
    const getProduct = (handle) => {
      if (fetchCache[handle]) return fetchCache[handle];
      fetchCache[handle] = fetch(rootUrl + '/products/' + handle + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
      return fetchCache[handle];
    };

    const optionValues = (product, name) => {
      if (!product || !product.options) return '';
      const idx = product.options.findIndex(
        (o) => (o.name || o) === name
      );
      if (idx < 0) return '';
      const key = 'option' + (idx + 1);
      const seen = [];
      (product.variants || []).forEach((v) => {
        if (v[key] && seen.indexOf(v[key]) === -1) seen.push(v[key]);
      });
      return seen.join(', ');
    };

    // Price row: custom.compare_function_price_metric is a 1-based variant index
    // (stashed on the trigger) — 4 → the 4th variant's price, 3 → the 3rd, etc.
    // Falls back to the 4th variant, else first available (else first variant),
    // else the stashed money string before the product.js fetch resolves.
    const comparePrice = (item, product) => {
      const variants = (product && product.variants) || [];
      const idx = parseInt(item.meta && item.meta.priceMetric, 10);
      if (!isNaN(idx) && variants[idx - 1]) return formatMoney(variants[idx - 1].price);
      const variant = variants[3] || variants.find((v) => v.available) || variants[0];
      if (variant) return formatMoney(variant.price);
      return item.price || '';
    };

    const rowValue = (row, item, product) => {
      switch (row.source) {
        case 'price': return comparePrice(item, product);
        case 'material': return item.meta ? item.meta.material : '';
        case 'type': return product ? product.type : '';
        case 'vendor': return product ? product.vendor : '';
        case 'availability': return product ? (product.available ? 'In stock' : 'Out of stock') : '';
        case 'tags': return product && product.tags ? product.tags.join(', ') : '';
        case 'option': return optionValues(product, row.option || '');
        default: return '';
      }
    };

    /* ---- metafield-backed tier rows (thickness / weight) ----
       Values ride on the trigger button (data-compare-thickness / -weight)
       and are stashed in item.meta — product.js never returns metafields. The
       stored value is "{number}{unit}" (e.g. "12mm" / "6.5kg"), so the unit is
       stripped before bucketing into a 3-bar tier:
         thickness (realmedia.pile_height, mm): SLIM <10 · BALANCED 10–24.99 · PLUSH 25+
         weight    (custom.rug_weight, kg):     Light <5 · Medium 5–7.99 · Heavy 8+
       Rendered as a 3-bar graph + caption (thickness shows "Name" + number;
       weight shows "Name - Xkg"). */
    const TIER_CONFIG = {
      thickness: { labels: ['SLIM', 'BALANCED', 'PLUSH'], unit: 'mm', tier: (n) => (n < 10 ? 1 : n < 25 ? 2 : 3) },
      weight: { labels: ['Light', 'Medium', 'Heavy'], unit: 'kg', tier: (n) => (n < 5 ? 1 : n < 8 ? 2 : 3) }
    };
    const tierInfo = (raw, kind) => {
      const cfg = TIER_CONFIG[kind];
      if (!cfg || raw == null || raw === '') return null;
      const n = parseFloat(String(raw).trim());
      if (isNaN(n)) return null;
      const tier = cfg.tier(n);
      // parseFloat already drops a trailing ".0" (12.0 → 12) while keeping 12.5.
      return { tier: tier, label: cfg.labels[tier - 1], number: String(n), unit: cfg.unit };
    };
    // Thickness and weight share one layout: bars with the number to their
    // right, and the (uppercase) tier name below them.
    const tierGraph = (info) => {
      const bars = [7, 11, 15].map((h, i) => {
        const cls = i < info.tier ? 'fill-(--color-accent)' : 'fill-(--color-fg)/15';
        return '<rect x="' + (i * 8) + '" y="' + (15 - h) + '" width="5.5" height="' + h + '" rx="1.2" class="' + cls + '"/>';
      }).join('');
      const svg = '<svg viewBox="0 0 21.5 15" width="24" height="17" aria-hidden="true">' + bars + '</svg>';
      const capCls = 'font-sans text-[11px] font-normal leading-3 tracking-[-0.02em]';
      return '<span class="inline-flex flex-col items-center gap-1">' +
        '<span class="inline-flex items-center gap-1.5">' + svg +
          '<span class="' + capCls + ' text-(--color-muted)">' + escapeHtml(info.number + info.unit) + '</span>' +
        '</span>' +
        '<span class="' + capCls + ' uppercase text-(--color-fg)">' + escapeHtml(info.label) + '</span>' +
        '</span>';
    };

    /* Case-insensitive check for a realmedia.product_features label on an item. */
    const hasFeature = (item, label) => {
      if (!label || !item.meta || !item.meta.features) return false;
      const want = String(label).trim().toLowerCase();
      return item.meta.features.split('|').some((f) => f.trim().toLowerCase() === want);
    };

    /* full HTML for a value cell, or '' when there is nothing to show */
    const rowCellHtml = (row, item, product) => {
      if (row.source === 'thickness' || row.source === 'weight') {
        const info = tierInfo(item.meta ? item.meta[row.source] : '', row.source);
        return info ? tierGraph(info) : '';
      }
      const icons = config.icons || {};
      const iconSpan = (svg, label) =>
        '<span class="inline-flex h-6 w-6 shrink-0 items-center justify-center text-(--color-fg) [&>svg]:h-full [&>svg]:w-auto [&>svg]:fill-current" aria-label="' + escapeHtml(label) + '">' + svg + '</span>';
      // Machine Washable: washing icon when the "Machine Washable" feature is set.
      if (row.source === 'machine_washable') {
        return hasFeature(item, 'Machine Washable') && icons.washing ? iconSpan(icons.washing, 'Machine washable') : '';
      }
      // Spill Resistant: a tick when the "Liquid Repellent" feature is set.
      if (row.source === 'spill_resistant') {
        return hasFeature(item, 'Liquid Repellent') ? '<span class="text-(--color-accent)">' + checkSvg + '</span>' : '';
      }
      // Pet & Child Friendly: baby + paw icons — only when BOTH washable and repellent are set.
      if (row.source === 'pet_child_friendly') {
        return hasFeature(item, 'Machine Washable') && hasFeature(item, 'Liquid Repellent')
          ? (icons.baby ? iconSpan(icons.baby, 'Child friendly') : '') + (icons.paw ? iconSpan(icons.paw, 'Pet friendly') : '')
          : '';
      }
      // Easy Clean: an icon per matching feature (no tick). '' → dash when none match.
      if (row.source === 'easy_clean') {
        return [
          ['machine washable', icons.washing],
          ['liquid repellent', icons.baby],
          ['pet friendly', icons.paw]
        ]
          .filter((pair) => pair[1] && hasFeature(item, pair[0]))
          .map((pair) => iconSpan(pair[1], pair[0]))
          .join('');
      }
      // Feature check: a tick when the configured feature label is present.
      if (row.source === 'feature_check') {
        return hasFeature(item, row.match) ? '<span class="text-(--color-accent)">' + checkSvg + '</span>' : '';
      }
      // Delivery: custom.pdp_boxed → "Boxed" when 1/true, otherwise "Rolled".
      if (row.source === 'boxed') {
        const b = String((item.meta && item.meta.boxed) || '').trim().toLowerCase();
        return '<span>' + (b === '1' || b === 'true' ? 'Boxed' : 'Rolled') + '</span>';
      }
      const val = rowValue(row, item, product);
      if (!val) return '';
      return (row.check ? '<span class="text-(--color-accent)">' + checkSvg + '</span>' : '') +
        '<span>' + escapeHtml(val) + '</span>';
    };

    // Currency comes from the active market; the locale comes from the storefront,
    // not the browser — otherwise a UK shopper with a French browser saw "129,99 £".
    // No 'USD' fallback: defaulting to dollars in a GBP/EUR store is never right.
    const formatMoney = (cents) => {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
      const locale = document.documentElement.lang || undefined;
      if (!currency) return '';
      try { return (cents / 100).toLocaleString(locale, { style: 'currency', currency }); }
      catch (e) { return ''; }
    };

    /* ---- render ---- */
    const render = () => {
      const items = read().slice(0, MAX);
      countEl.textContent = items.length + ' ' + config.selectedSingular;
      grid.innerHTML = '';

      const slots = [];
      for (let i = 0; i < MAX; i++) slots.push(items[i] || null);

      const cell = (cls, html) => {
        const d = document.createElement('div');
        d.className = cls;
        if (html != null) d.innerHTML = html;
        return d;
      };

      /* header row: label cell (holds "Clear all" when populated) + product/empty cells */
      grid.appendChild(cell(
        'flex items-end border-b-[3px] border-b-(--color-border) pb-4',
        items.length
          ? '<button type="button" data-compare-clear class="inline-flex cursor-pointer items-center font-sans text-[14px] leading-4.5 tracking-[-0.03em] text-(--color-muted) underline transition hover:text-(--color-fg) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--color-accent) lg:text-[16px] lg:leading-5">' + escapeHtml(config.clearLabel) + '</button>'
          : null
      ));
      slots.forEach((item) => {
        if (item) {
          const c = cell('relative flex flex-col items-center gap-2 border-b-[3px] border-b-(--color-border) px-3 pb-4 pt-3 text-center');
          c.innerHTML =
            '<button type="button" class="absolute right-1 top-1 inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded-full text-(--color-muted) transition hover:text-(--color-fg)" aria-label="Remove" data-compare-remove="' + item.handle + '">' + closeSvg + '</button>' +
            '<a href="' + item.url + '" class="block aspect-[5/6] w-full max-w-[120px] overflow-hidden bg-(--color-surface)">' +
            (item.image ? '<img src="' + item.image + '" alt="" loading="lazy" class="h-full w-full object-cover">' : '') +
            '</a>' +
            '<a href="' + item.url + '" class="line-clamp-2 font-sans text-[14px] font-normal leading-4.5 tracking-[-0.03em] text-(--color-fg) no-underline hover:underline lg:text-[16px] lg:leading-5.5">' + escapeHtml(item.title) + '</a>';
          grid.appendChild(c);
        } else {
          const c = cell('flex items-center justify-center border-b-[3px] border-b-(--color-border) px-3 py-6');
          c.innerHTML =
            '<button type="button" data-compare-add class="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-(--color-fg)/25 text-(--color-fg)/50 transition hover:border-(--color-fg)/50 hover:text-(--color-fg) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--color-accent)" aria-label="' + escapeHtml(config.emptyLabel) + '">' + plusSvg + '</button>';
          grid.appendChild(c);
        }
      });

      /* spec rows */
      config.rows.forEach((row) => {
        /* optional sub-label under the row header, e.g. the reference size a
           price or weight is quoted at ("160cm x 230cm") */
        const labelHtml = row.sublabel
          ? '<span class="flex flex-col gap-0.5">' +
              '<span>' + escapeHtml(row.label) + '</span>' +
              '<span class="font-sans text-[11px] font-normal leading-3 tracking-[-0.02em] text-(--color-muted)">' + escapeHtml(row.sublabel) + '</span>' +
            '</span>'
          : escapeHtml(row.label);
        grid.appendChild(
          cell('flex min-h-12.5 items-center border-b border-(--color-fg)/10 py-1.5 pr-3 font-sans text-[14px] font-medium leading-4.5 tracking-[-0.03em] text-(--color-fg) lg:text-[16px] lg:leading-5', labelHtml)
        );
        slots.forEach((item, i) => {
          const c = cell('flex min-h-12.5 items-center gap-2 border-b border-(--color-fg)/10 py-1.5 px-3 font-sans text-[14px] font-medium leading-4.5 tracking-[-0.03em] text-(--color-fg) lg:text-[16px] lg:leading-5');
          if (item) {
            c.dataset.compareValue = item.handle + '|' + i;
            c.dataset.compareRow = config.rows.indexOf(row);
            c.innerHTML = '<span class="text-(--color-muted)">' + config.loadingLabel + '</span>';
          }
          grid.appendChild(c);
        });
      });

      /* buy row */
      grid.appendChild(cell('py-4'));
      slots.forEach((item) => {
        const c = cell('px-2 py-4');
        if (item) {
          c.innerHTML =
            '<a href="' + item.url + '" class="inline-flex h-11 w-full items-center justify-center rounded-full bg-(--color-accent) px-4 text-button font-mono uppercase text-(--color-accent-fg) no-underline transition hover:opacity-90">' + escapeHtml(config.buyLabel) + '</a>';
        }
        grid.appendChild(c);
      });

      /* fill spec cells once product data resolves */
      items.forEach((item, i) => {
        getProduct(item.handle).then((product) => {
          config.rows.forEach((row, ri) => {
            const c = grid.querySelector('[data-compare-value="' + item.handle + '|' + i + '"][data-compare-row="' + ri + '"]');
            if (!c) return;
            c.innerHTML = rowCellHtml(row, item, product) || '<span class="text-(--color-muted)">&mdash;</span>';
          });
          if (!isCollapsed()) bodyEl.style.maxHeight = bodyEl.scrollHeight + 'px';
        });
      });

      if (!isCollapsed()) requestAnimationFrame(() => { bodyEl.style.maxHeight = bodyEl.scrollHeight + 'px'; });
    };

    const escapeHtml = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      ));

    /* sync the active state of every compare trigger on the page */
    const syncTriggers = () => {
      const handles = read().map((i) => i.handle);
      document.querySelectorAll('[data-compare-toggle]').forEach((btn) => {
        const active = handles.indexOf(btn.dataset.compareHandle) !== -1;
        if (active) btn.dataset.compareActive = '';
        else delete btn.dataset.compareActive;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    /* briefly pulse every compare toggle on the page to point the shopper at
       where products get added (fired by the empty-slot "+") */
    const flashTriggers = () => {
      const btns = document.querySelectorAll('[data-compare-toggle]');
      btns.forEach((btn) => {
        btn.classList.remove('compare-flash');
        void btn.offsetWidth; /* restart the animation if already running */
        btn.classList.add('compare-flash');
      });
      window.setTimeout(() => {
        document.querySelectorAll('.compare-flash').forEach((b) => b.classList.remove('compare-flash'));
      }, 1600);
    };

    /* Swipe/drag guard. Compare toggles are rendered once per slide over the
       PDP's native touch-scroll gallery, so a swipe can end as a synthetic
       click on a toggle and add the product. Track pointer travel between down
       and up and suppress clicks that are really the tail of a swipe/drag. */
    const DRAG_THRESHOLD = 10; // px
    let downX = 0, downY = 0, wasDrag = false;
    document.addEventListener('pointerdown', (e) => {
      downX = e.clientX; downY = e.clientY; wasDrag = false;
    }, true);
    document.addEventListener('pointerup', (e) => {
      wasDrag = Math.abs(e.clientX - downX) > DRAG_THRESHOLD ||
                Math.abs(e.clientY - downY) > DRAG_THRESHOLD;
    }, true);

    /* ---- events ---- */
    const toggle = (btn) => {
      const handle = btn.dataset.compareHandle;
      if (!handle) return;
      let items = read();
      const idx = items.findIndex((i) => i.handle === handle);
      if (idx !== -1) {
        items.splice(idx, 1);
      } else {
        if (items.length >= MAX) items = items.slice(1); /* drop oldest to make room */
        items.push({
          handle: handle,
          title: btn.dataset.compareTitle || handle,
          image: btn.dataset.compareImage || '',
          url: btn.dataset.compareUrl || (rootUrl + '/products/' + handle),
          price: btn.dataset.comparePrice || '',
          meta: {
            thickness: btn.dataset.compareThickness || '',
            weight: btn.dataset.compareWeight || '',
            features: btn.dataset.compareFeatures || '',
            boxed: btn.dataset.compareBoxed || '',
            priceMetric: btn.dataset.comparePriceMetric || '',
            material: btn.dataset.compareMaterial || ''
          }
        });
      }
      write(items);
      syncTriggers();
      render();
      if (items.length > 0) { show(); applyCollapsed(isCollapsed()); }
      else hide();
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-compare-toggle]');
      if (trigger) { e.preventDefault(); if (wasDrag) return; toggle(trigger); return; }
      const add = e.target.closest('[data-compare-add]');
      if (add) { e.preventDefault(); hide(); flashTriggers(); return; }
      const clear = e.target.closest('[data-compare-clear]');
      if (clear) {
        e.preventDefault();
        write([]);
        syncTriggers();
        render();
        hide();
        return;
      }
      const remove = e.target.closest('[data-compare-remove]');
      if (remove) {
        const handle = remove.getAttribute('data-compare-remove');
        write(read().filter((i) => i.handle !== handle));
        syncTriggers();
        render();
        if (read().length === 0) hide();
        return;
      }
    });

    /* collapse the bar when clicking anywhere outside it — but ignore clicks on
       a compare toggle (those live outside the panel and add/remove products,
       which should keep the bar expanded) */
    document.addEventListener('click', (e) => {
      if (root.classList.contains('hidden') || isCollapsed()) return;
      if (e.target.closest('[data-compare-panel]')) return;
      if (e.target.closest('[data-compare-toggle]')) return;
      localStorage.setItem(COLLAPSE_KEY, '1');
      applyCollapsed(true);
    });

    /* hide the bar while the cart drawer is open so it can't cover the
       checkout button; the attribute is independent of the bar's own
       hidden state, so it returns to normal once the cart closes */
    document.addEventListener('cart-drawer:open', () => { root.dataset.cartOpen = ''; });
    document.addEventListener('cart-drawer:close', () => { delete root.dataset.cartOpen; });

    /* ---- init ---- */
    render();
    syncTriggers();
    if (read().length > 0) {
      show();
      applyCollapsed(isCollapsed());
    }

    /* repaint trigger active-state when compare buttons appear after load —
       Algolia results and deferred sections cloned into the DOM on scroll
       (mirrors the MutationObserver in wishlist.js). */
    if (window.MutationObserver && document.body) {
      let scheduled = false;
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; syncTriggers(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewSlider extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-scroller]');
      const prev = this.querySelector('[data-slider-prev]');
      const next = this.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => this.scroll(-1));
      if (next) next.addEventListener('click', () => this.scroll(1));

      // "See all reviews" opens the <reviews-drawer> (the Reviews.io Polaris widget);
      // that element listens for [data-reviews-see-all] clicks via document delegation.

      // Live Reviews.io data (opt-in via data-reviewsio-store on this element):
      // per-product (needs a SKU) or store-wide (scope="store", no SKU required).
      if (this.dataset.reviewsioStore && (this.dataset.reviewsioSku || this.dataset.reviewsioScope === 'store')) this.loadReviewsio();
    }

    scroll(direction) {
      if (!this.scroller) return;
      const card = this.scroller.querySelector('article');
      const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 16;
      const step = card ? card.offsetWidth + gap : this.scroller.clientWidth * 0.8;
      this.scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    // ----- Reviews.io -----
    async loadReviewsio() {
      const store = this.dataset.reviewsioStore;
      const sku = this.dataset.reviewsioSku;
      const scope = this.dataset.reviewsioScope || 'product';
      const max = parseInt(this.dataset.reviewsioMax, 10) || 12;
      const minRating = parseInt(this.dataset.reviewsioMinRating, 10) || 0;
      // Public reads need no API key. Store-wide uses /product/reviews/all — a flat
      // catalogue-wide product-review feed that honours minRating + sort. Product mode
      // uses the per-SKU endpoints. Response shapes differ, so parsing is defensive.
      let urls;
      if (scope === 'store') {
        let base = `https://api.reviews.io/product/reviews/all?store=${encodeURIComponent(store)}&per_page=${max}&sort=highest_rating`;
        if (minRating) base += `&minRating=${minRating}`;
        urls = [base];
      } else {
        // Per-SKU: /product/review is the confirmed keyless endpoint (tried first);
        // /reviews?sku is a secondary fallback that 401s on some accounts.
        urls = [
          `https://api.reviews.io/product/review?store=${encodeURIComponent(store)}&sku=${encodeURIComponent(sku)}&per_page=${max}`,
          `https://api.reviews.io/reviews?store=${encodeURIComponent(store)}&sku=${encodeURIComponent(sku)}&type=product_review&per_page=${max}`,
        ];
      }
      let data = null;
      for (const url of urls) {
        try {
          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!res.ok) continue;
          const json = await res.json();
          if (this.extractReviews(json).length) { data = json; break; }
          if (!data) data = json; // keep for a possible stats-only summary
        } catch (e) { /* try next */ }
      }
      if (!data) return; // leave manual fallback in place

      // Client-side rating floor as a safety net — the endpoint's minRating isn't
      // guaranteed to be honoured across the different response shapes.
      let reviews = this.extractReviews(data);
      if (minRating) {
        reviews = reviews.filter((r) => (this.num(this.pick(r, ['rating', 'review_rating', 'score', 'stars'])) || 0) >= minRating);
      }
      reviews = reviews.slice(0, max);

      if (reviews.length) this.renderCards(reviews);
      // In store-wide mode the visible cards are a filtered (e.g. 5★) slice, so a live
      // average/total would misrepresent the catalogue — keep the merchant's manual
      // summary. Product mode still reflects that product's real stats.
      if (scope !== 'store') this.renderSummary(data, reviews.length);
    }

    pick(obj, keys) {
      if (!obj) return undefined;
      for (const k of keys) if (obj[k] != null && obj[k] !== '') return obj[k];
      return undefined;
    }

    num(v) { const n = parseFloat(v); return isNaN(n) ? null : n; }

    extractReviews(data) {
      if (!data) return [];
      let list = data.reviews;
      if (list && !Array.isArray(list) && Array.isArray(list.data)) list = list.data;
      if (!Array.isArray(list)) list = Array.isArray(data) ? data : [];
      return list;
    }

    renderSummary(data, shownCount) {
      const statsObj = data.stats || data.rating || data;
      const avg = this.num(this.pick(statsObj, ['average_rating', 'average', 'rating', 'overall_rating', 'score']));
      const total = this.num(this.pick(statsObj, ['total_reviews', 'total', 'count', 'num_ratings', 'review_count'])) || shownCount;

      const numEl = this.querySelector('[data-reviewsio-rating-number]');
      if (numEl && avg != null) numEl.textContent = avg.toFixed(1);

      const starsEl = this.querySelector('[data-reviewsio-stars]');
      if (starsEl && avg != null) {
        starsEl.innerHTML = this.starsHtml(avg, 29, '27.58', 'text-(--color-muted)');
        starsEl.setAttribute('aria-label', `${avg.toFixed(1)} out of 5 stars`);
      }

      const countEl = this.querySelector('[data-reviewsio-count]');
      if (countEl && total != null) {
        const suffix = this.dataset.reviewsioCountSuffix || 'reviews';
        countEl.textContent = `${total.toLocaleString()} ${suffix}`;
      }
    }

    starsHtml(rating, width, height, colorClass) {
      const filled = Math.round(rating);
      let out = '';
      for (let i = 1; i <= 5; i++) {
        const dim = i <= filled ? '' : ' opacity-30';
        out +=
          `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 13.622 12.955" class="${colorClass}${dim}" aria-hidden="true">` +
          '<path d="M6.811,0,5.2,4.949H0L4.21,8.007,2.6,12.955,6.811,9.9l4.21,3.058L9.413,8.007l4.209-3.058h-5.2Z" fill="currentColor"/></svg>';
      }
      return out;
    }

    // Reviews.io returns HTML-encoded text (e.g. &quot;, &amp;, &#39;) — and
    // sometimes DOUBLE-encoded (&amp;quot;). Decode repeatedly until stable so no
    // entity survives; otherwise a single pass leaves "&quot;" which esc() then
    // re-encodes to "&amp;quot;" and renders as the literal text "&quot;".
    decodeEntities(s) {
      if (s == null) return '';
      const t = document.createElement('textarea');
      let str = String(s);
      for (let i = 0; i < 5; i++) {
        t.innerHTML = str;
        const decoded = t.value;
        if (decoded === str) break;
        str = decoded;
      }
      return str;
    }

    esc(s) {
      const d = document.createElement('div');
      d.textContent = this.decodeEntities(s);
      return d.innerHTML;
    }

    reviewerName(r) {
      const direct = this.pick(r, ['author', 'reviewer_name', 'name']);
      if (direct) return direct;
      const reviewer = r.reviewer || r.customer || {};
      if (typeof reviewer === 'object') {
        const parts = [this.pick(reviewer, ['first_name', 'firstname']), this.pick(reviewer, ['last_name', 'lastname'])].filter(Boolean);
        if (parts.length) return parts.join(' ');
        const n = this.pick(reviewer, ['name', 'display_name']);
        if (n) return n;
      }
      return '';
    }

    renderCards(reviews) {
      if (!this.scroller) return;
      // Verified-buyer tick badge (theme icon-tick.svg) in place of an avatar.
      const tickSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-tick h-full w-full" viewBox="0 0 20 20">' +
        '<path fill="#108043" stroke="#fff" d="m16.136 6.979.003-.004a1.499 1.499 0 0 0-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 1 0 3.94 12.06l2.999 3c.289.29.675.44 1.1.439h.019a1.5 1.5 0 0 0 1.08-.522z"/></svg>';
      const avatarHtml =
        '<span class="flex h-7 w-7 shrink-0 items-center justify-center" aria-hidden="true">' + tickSvg + '</span>';
      const cards = reviews.map((r, i) => {
        const last = i === reviews.length - 1;
        const rating = this.num(this.pick(r, ['rating', 'review_rating', 'score', 'stars'])) || 0;
        const title = this.esc(this.pick(r, ['title', 'heading', 'review_title']) || '');
        const body = this.esc(this.pick(r, ['review', 'comments', 'content', 'body', 'text', 'description']) || '');
        const name = this.esc(this.reviewerName(r));

        const nameHtml = name
          ? `<span class="font-sans text-xs leading-4 tracking-[-0.03em] text-(--color-fg)">${name}</span>`
          : '';
        const titleHtml = title
          ? `<h3 class="m-0 font-sans text-base font-semibold leading-5 tracking-[-0.03em] text-(--color-fg)">${title}</h3>`
          : '';
        const bodyHtml = body
          ? `<p class="m-0 line-clamp-8 font-sans text-sm leading-[18px] tracking-[-0.03em] text-(--color-muted)">${body}</p>`
          : '';

        return (
          `<article class="flex h-[225px] w-[268px] shrink-0 flex-col gap-2 rounded-[10px] border border-(--color-fg)/10 bg-(--color-surface) p-3 pb-5 snap-center ${last ? 'lg:snap-end' : 'lg:snap-start'}">` +
          '<div class="flex items-center justify-between">' +
          `<div class="flex items-center gap-2">${avatarHtml}${nameHtml}</div>` +
          `<span class="flex items-center gap-px" aria-label="${rating} out of 5 stars">${this.starsHtml(rating, 11, '10.5', 'text-(--color-muted)')}</span>` +
          '</div>' +
          titleHtml +
          bodyHtml +
          '</article>'
        );
      });
      this.scroller.innerHTML = cards.join('');
    }
  }
  customElements.define('review-slider', ReviewSlider);

  // Slide-in drawer hosting the full Reviews.io Polaris widget. Opened by any
  // [data-reviews-see-all] trigger (See-all links in the slider). The widget is
  // heavy, so it is only initialised the first time the drawer opens: the config
  // is stashed on window.__kukoonReviewsWidgetConfig by the Liquid <script>, and
  // loadWidget() injects build.js then calls new ReviewsWidget() once.
  class ReviewsDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-reviews-drawer]');
      this.overlay = this.querySelector('[data-reviews-drawer-overlay]');
      this.mount = this.querySelector('[data-reviews-widget-mount]');
      this.closeTimer = null;
      this.lastFocus = null;
      this.widgetLoaded = false;

      // Triggers live inside the (possibly deferred) slider, so delegate on document.
      this.onSeeAll = (e) => {
        const trigger = e.target.closest && e.target.closest('[data-reviews-see-all]');
        if (!trigger) return;
        e.preventDefault();
        this.open(trigger);
      };
      document.addEventListener('click', this.onSeeAll);

      this.querySelectorAll('[data-reviews-drawer-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      this.onKeydown = (e) => {
        if (e.key === 'Escape' && this.panel && this.panel.dataset.active !== undefined) this.close();
      };
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onSeeAll);
      document.removeEventListener('keydown', this.onKeydown);
    }

    open(trigger) {
      if (!this.panel) return;
      this.lastFocus = trigger || document.activeElement;
      window.clearTimeout(this.closeTimer);
      this.loadWidget();
      this.panel.hidden = false;
      requestAnimationFrame(() => {
        this.panel.dataset.active = '';
        if (this.overlay) this.overlay.dataset.active = '';
        this.panel.focus();
      });
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      if (!this.panel) return;
      delete this.panel.dataset.active;
      if (this.overlay) delete this.overlay.dataset.active;
      document.documentElement.style.overflow = '';
      this.closeTimer = window.setTimeout(() => { this.panel.hidden = true; }, 300);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        try { this.lastFocus.focus(); } catch (e) {}
      }
    }

    loadWidget() {
      if (this.widgetLoaded) return;
      const cfg = (window.__kukoonReviewsWidgetConfig || {})[this.dataset.configKey];
      if (!this.mount || !this.mount.id || !cfg) return;
      this.widgetLoaded = true;
      const run = () => {
        try { new window.ReviewsWidget('#' + this.mount.id, cfg); } catch (e) { /* noop */ }
      };
      if (window.ReviewsWidget) { run(); return; }
      // Reuse the build.js tag if another drawer already injected it.
      let script = document.querySelector('script[data-reviewsio-build]');
      if (script) { script.addEventListener('load', run); return; }
      script = document.createElement('script');
      script.src = 'https://widget.reviews.io/polaris/build.js';
      script.async = true;
      script.setAttribute('data-reviewsio-build', '');
      script.addEventListener('load', run);
      document.head.appendChild(script);
    }
  }
  customElements.define('reviews-drawer', ReviewsDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollections extends HTMLElement {
    connectedCallback() {
      this.scrollEl = this.querySelector('[data-fc-scroll]');
      if (!this.scrollEl) return;
      this._center = this._center.bind(this);
      this._center();
      window.addEventListener('resize', this._center);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._center);
    }

    _center() {
      if (window.matchMedia('(min-width: 1024px)').matches) return;
      const max = this.scrollEl.scrollWidth - this.scrollEl.clientWidth;
      if (max > 0) this.scrollEl.scrollLeft = max / 2;
    }
  }
  customElements.define('featured-collections', FeaturedCollections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // Read the height once here (on init + breakpoint change) and cache it, so the
      // per-scroll reveal()/reset() don't repeatedly read offsetHeight (forced reflow).
      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      if (!this.header.classList.contains('shopify-section-header-hidden')) {
        document.documentElement.style.setProperty('--header-offset', `${this.headerHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.documentElement.style.setProperty('--header-offset', '0px');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.classList.add('header-animate');
      document.documentElement.style.setProperty('--header-offset', `${this.headerHeight}px`);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.documentElement.classList.remove('header-animate');
      document.documentElement.style.setProperty('--header-offset', `${this.headerHeight}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function setupSearchOverlay() {
    const overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    const input = overlay.querySelector('[data-search-overlay-input]');
    const closeBtns = overlay.querySelectorAll('[data-search-overlay-close]');
    const tabs = overlay.querySelectorAll('[data-search-overlay-tab]');
    const panels = overlay.querySelectorAll('[data-search-overlay-panel]');
    let lastFocus = null;

    const open = (trigger) => {
      if (!overlay.hidden && !overlay.classList.contains('hidden')) return;
      lastFocus = trigger || document.activeElement;
      const headerEl = document.querySelector('.section-header');
      if (headerEl) {
        document.documentElement.style.setProperty(
          '--header-bottom-position',
          `${parseInt(headerEl.getBoundingClientRect().bottom)}px`
        );
      }
      overlay.hidden = false;
      overlay.classList.remove('hidden');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        const inputs = overlay.querySelectorAll('input[type="search"][data-search-overlay-input]');
        const visibleInput = Array.from(inputs).find((i) => i.offsetParent !== null);
        (visibleInput || input)?.focus();
      });
    };

    const close = () => {
      overlay.hidden = true;
      overlay.classList.add('hidden');
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.blur(); } catch (e) {}
      }
    };

    document.querySelectorAll('[data-search-overlay-open]').forEach((el) => {
      const handler = (e) => {
        e.preventDefault();
        if (el.tagName === 'INPUT') el.blur();
        open(el);
      };
      el.addEventListener('click', handler);
      if (el.tagName === 'INPUT') el.addEventListener('focus', handler);
    });

    closeBtns.forEach((btn) => btn.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-search-overlay-tab');
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((p) => {
          p.classList.toggle('hidden', p.getAttribute('data-search-overlay-panel') !== target);
        });
      });
    });
  })();

  (function setupLocalizationSlideout() {
    const slideout = document.querySelector('[data-localization-slideout]');
    if (!slideout) return;

    const triggers = document.querySelectorAll('[data-header-localization-trigger]');
    const closeEls = slideout.querySelectorAll('[data-localization-slideout-close]');
    const overlay = slideout.querySelector('[data-localization-slideout-overlay]');
    let lastFocus = null;
    let closeTimer = null;

    const open = (trigger) => {
      lastFocus = trigger || document.activeElement;
      window.clearTimeout(closeTimer);
      slideout.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        slideout.dataset.state = 'open';
        const focusEl = slideout.querySelector('[data-localization-slideout-close]');
        focusEl && focusEl.focus();
      });
    };

    const close = () => {
      slideout.dataset.state = 'closed';
      document.documentElement.style.overflow = '';
      closeTimer = window.setTimeout(() => {
        slideout.hidden = true;
      }, 300);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    };

    triggers.forEach((t) => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        open(t);
      });
    });
    closeEls.forEach((c) => c.addEventListener('click', close));
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !slideout.hidden) close();
    });
  })();

  document.querySelectorAll('[data-mega-nav-panel]').forEach((panel) => {
    const trigger = panel.closest('li');
    if (!trigger) return;
    const activate = () => {
      const template = panel.querySelector('[data-mega-nav-template]');
      if (!template) return;
      panel.appendChild(template.content.cloneNode(true));
      template.remove();
    };
    trigger.addEventListener('mouseenter', activate, { once: true });
    trigger.addEventListener('focusin', activate, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-cards"] && !Shopify.designMode) return;
  try {
    
  (function setupInfoCardDrawers() {
    // Delegated so it also covers drawers cloned in when a deferred section activates.
    if (window.__infoCardDrawersReady) return;
    window.__infoCardDrawersReady = true;

    let lastFocus = null;
    const timers = new WeakMap();
    const panelOf = (drawer) => drawer.querySelector('[data-info-drawer-panel]');
    const overlayOf = (drawer) => drawer.querySelector('[data-info-drawer-overlay]');

    const openDrawer = (drawer, trigger) => {
      const panel = panelOf(drawer);
      if (!panel) return;
      const overlay = overlayOf(drawer);
      lastFocus = trigger || document.activeElement;
      window.clearTimeout(timers.get(drawer));
      panel.hidden = false;
      requestAnimationFrame(() => {
        panel.dataset.active = '';
        if (overlay) overlay.dataset.active = '';
        panel.focus();
      });
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = (drawer) => {
      const panel = panelOf(drawer);
      if (!panel) return;
      const overlay = overlayOf(drawer);
      delete panel.dataset.active;
      if (overlay) delete overlay.dataset.active;
      document.documentElement.style.overflow = '';
      timers.set(drawer, window.setTimeout(() => { panel.hidden = true; }, 300));
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    };

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-info-drawer-open]');
      if (opener) {
        const drawer = document.querySelector('[data-info-drawer="' + opener.getAttribute('data-info-drawer-open') + '"]');
        if (drawer) { e.preventDefault(); openDrawer(drawer, opener); }
        return;
      }
      const closer = e.target.closest('[data-info-drawer-close], [data-info-drawer-overlay]');
      if (closer) {
        const drawer = closer.closest('[data-info-drawer]');
        if (drawer) closeDrawer(drawer);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-info-drawer]').forEach((drawer) => {
        const panel = panelOf(drawer);
        if (panel && panel.dataset.active !== undefined) closeDrawer(drawer);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  class MainCollection extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-mc-form]');
      this.drawer = this.querySelector('[data-mc-drawer]');
      this.drawerPanel = this.querySelector('[data-mc-drawer-panel]');
      this.drawerForm = this.querySelector('[data-mc-drawer-form]');

      const openBtn = this.querySelector('[data-mc-open-drawer]');
      const closeBtn = this.querySelector('[data-mc-drawer-close]');
      const overlay = this.querySelector('[data-mc-drawer-overlay]');

      // Load more
      this.grid = this.querySelector('[data-mc-grid]');
      const loadMoreBtn = this.querySelector('[data-mc-loadmore-button]');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this._loadMore(loadMoreBtn);
        });
      }

      if (openBtn) openBtn.addEventListener('click', () => this._openDrawer());
      if (closeBtn) closeBtn.addEventListener('click', () => this._closeDrawer());
      if (overlay) overlay.addEventListener('click', () => this._closeDrawer());

      // Auto-submit on inline checkbox / sort change
      this.querySelectorAll('[data-mc-auto-submit]').forEach((el) => {
        el.addEventListener('change', () => {
          if (this.form) this._submitForm(this.form);
        });
      });

      // Close inline dropdowns on outside click
      this.querySelectorAll('[data-mc-filter-dropdown]').forEach((details) => {
        document.addEventListener('click', (e) => {
          if (!details.contains(e.target) && details.open) details.open = false;
        });
      });

      // Escape closes drawer
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer && !this.drawer.classList.contains('invisible')) {
          this._closeDrawer();
        }
      });
    }

    _openDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.remove('invisible', 'opacity-0');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        if (this.drawerPanel) this.drawerPanel.setAttribute('data-open', '');
      });
    }

    _closeDrawer() {
      if (!this.drawer) return;
      if (this.drawerPanel) this.drawerPanel.removeAttribute('data-open');
      this.drawer.classList.add('opacity-0');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(() => {
        if (this.drawer) this.drawer.classList.add('invisible');
      }, 200);
    }

    async _loadMore(btn) {
      const url = btn.getAttribute('data-next-url');
      if (!url || btn.hasAttribute('data-loading')) return;

      const label = btn.querySelector('[data-mc-loadmore-label]');
      const restore = label ? label.textContent : '';
      btn.setAttribute('data-loading', '');
      if (label) label.textContent = btn.getAttribute('data-loading-label') || restore;

      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        // Append the next page's grid items (products + any anchor blocks).
        const newGrid = doc.querySelector('[data-mc-grid]');
        if (newGrid && this.grid) {
          const frag = document.createDocumentFragment();
          Array.from(newGrid.children).forEach((li) => frag.appendChild(document.importNode(li, true)));
          this.grid.appendChild(frag);
        }

        // Update the "Viewing 1 – N of M products" tally.
        const newShown = doc.querySelector('[data-mc-shown]');
        const curShown = this.querySelector('[data-mc-shown]');
        if (newShown && curShown) curShown.textContent = newShown.textContent;

        // Point the button at the following page, or retire it on the last page.
        const nextBtn = doc.querySelector('[data-mc-loadmore-button]');
        if (nextBtn) {
          const nextUrl = nextBtn.getAttribute('data-next-url');
          btn.setAttribute('data-next-url', nextUrl);
          btn.setAttribute('href', nextUrl);
          if (label) label.textContent = restore;
          btn.removeAttribute('data-loading');
        } else {
          btn.remove();
        }
      } catch (e) {
        // Fall back to a normal page navigation if the fetch fails.
        window.location.href = url;
      }
    }

    _submitForm(form) {
      const formData = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, value] of formData.entries()) {
        if (value) params.append(key, value);
      }
      const url = `${window.location.pathname}?${params.toString()}`;
      window.location.href = url;
    }
  }
  customElements.define('main-collection', MainCollection);

  class CardMediaSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-card-track]');
      this.slides = Array.from(this.querySelectorAll('[data-card-slide]'));
      if (!this.track || this.slides.length < 2) return;

      // The pagination bar lives outside this element (underneath the image box),
      // so reach it through the shared card root.
      const root = this.closest('[data-quickbuy-root]') || this;
      this.progressFill = root.querySelector('[data-card-progress-fill]');

      // Prev / next arrows (inside this element).
      this.activeIndex = 0;
      this.prevBtn = this.querySelector('[data-card-prev]');
      this.nextBtn = this.querySelector('[data-card-next]');
      this.prevBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        this._go(-1);
      });
      this.nextBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        this._go(1);
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this._setActive(this.slides.indexOf(entry.target));
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((slide) => this.observer.observe(slide));
      this._setActive(0);

      // Desktop: hovering the card jumps instantly to the hover image (slide 2)
      // and back to the featured image on leave.
      this._onEnter = () => {
        if (!this._isDesktop()) return;
        this.track.scrollTo({ left: this.slides[1].offsetLeft, behavior: 'auto' });
      };
      this._onLeave = () => {
        if (!this._isDesktop()) return;
        this.track.scrollTo({ left: 0, behavior: 'auto' });
      };
      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);

      // The first slider on the page gives a one-time elastic "peek" hint so
      // shoppers can tell the card image is swipeable.
      if (!CardMediaSlider._hinted) {
        CardMediaSlider._hinted = true;
        this._scheduleHint();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
    }

    _isDesktop() {
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    _go(dir) {
      const target = Math.min(Math.max(this.activeIndex + dir, 0), this.slides.length - 1);
      this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: 'smooth' });
    }

    _scheduleHint() {
      // Mobile-only: the swipe hint is irrelevant on desktop (lg and up).
      if (window.matchMedia('(min-width: 1024px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setTimeout(() => requestAnimationFrame(() => this._peekHint()), 650);
    }

    _peekHint() {
      const slide = this.slides[0];
      if (!slide) return;
      const peek = slide.getBoundingClientRect().width * 0.25;
      if (peek <= 0) return;

      const prevBehavior = this.track.style.scrollBehavior;
      const prevSnap = this.track.style.scrollSnapType;
      this.track.style.scrollBehavior = 'auto';
      this.track.style.scrollSnapType = 'none';

      const easeOut = (t) => 1 - Math.pow(1 - t, 3);

      const outMs = 750;
      const backMs = 750;
      const start = performance.now();
      const step = (now) => {
        const elapsed = now - start;
        if (elapsed < outMs) {
          this.track.scrollLeft = peek * easeOut(elapsed / outMs);
        } else if (elapsed < outMs + backMs) {
          this.track.scrollLeft = Math.max(0, peek * (1 - easeOut((elapsed - outMs) / backMs)));
        } else {
          this.track.scrollLeft = 0;
          this.track.style.scrollBehavior = prevBehavior;
          this.track.style.scrollSnapType = prevSnap;
          return;
        }
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    _setActive(index) {
      if (index < 0) return;
      this.activeIndex = index;
      // The fill is one segment wide, so translating by index segments (its own
      // width = 100%) lands it under the active slide.
      if (this.progressFill) this.progressFill.style.transform = `translateX(${index * 100}%)`;
      // Only show an arrow when it has somewhere to go.
      if (this.prevBtn) this.prevBtn.toggleAttribute('data-disabled', index <= 0);
      if (this.nextBtn) this.nextBtn.toggleAttribute('data-disabled', index >= this.slides.length - 1);
    }
  }
  customElements.define('card-media-slider', CardMediaSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // Market-prefixed cart endpoints. 
  // so these come from window.routes (set in theme.liquid). A bare '/cart/add.js'
  // from an /en-fr page resolves in the default market and can return GBP pricing.
  const pdpCartRoute = (key, fallback) => `${(window.routes && window.routes[key]) || fallback}.js`;

  (function setupPDP() {
    document.querySelectorAll('[data-pdp-form]').forEach((form) => {
      const root = form.closest('section');

      // ----- Gallery sliders (mobile + desktop) + thumbnails + counters -----
      // Both breakpoints are horizontal snap sliders, one media per slide.
      // Each slide carries data-full (the width:1200 URL) so a variant change
      // can scroll the gallery to the variant's image by matching that URL.
      const mSlider = root.querySelector('[data-pdp-slider]');
      const dSlider = root.querySelector('[data-pdp-d-slider]');

      const sliderIndex = (s) => (s && s.clientWidth ? Math.round(s.scrollLeft / s.clientWidth) : 0);
      const scrollSliderTo = (s, index) => {
        if (s) s.scrollTo({ left: index * s.clientWidth, behavior: 'smooth' });
      };

      function setupSlider(slider, opts) {
        if (!slider) return;
        const count = slider.children.length;
        const currentEl = opts.currentEl;
        const thumbs = opts.thumbs || [];
        let lastIndex = -1;
        const sync = () => {
          const i = sliderIndex(slider);
          if (currentEl) currentEl.textContent = i + 1;
          thumbs.forEach((t, ti) => t.setAttribute('aria-current', ti === i ? 'true' : 'false'));
          // Slide the thumbnail row so the active thumb stays centred in view.
          if (i !== lastIndex && thumbs[i]) {
            const li = thumbs[i].parentElement;
            const row = li.parentElement;
            const rowRect = row.getBoundingClientRect();
            const liRect = li.getBoundingClientRect();
            const delta = (liRect.left + liRect.width / 2) - (rowRect.left + rowRect.width / 2);
            if (Math.abs(delta) > 1) row.scrollBy({ left: delta, behavior: 'smooth' });
          }
          lastIndex = i;
        };
        let ticking = false;
        slider.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => { sync(); ticking = false; });
        }, { passive: true });
        if (opts.prev) opts.prev.addEventListener('click', () => scrollSliderTo(slider, Math.max(0, sliderIndex(slider) - 1)));
        if (opts.next) opts.next.addEventListener('click', () => scrollSliderTo(slider, Math.min(count - 1, sliderIndex(slider) + 1)));
        thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => scrollSliderTo(slider, i)));
        sync();
      }

      setupSlider(mSlider, {
        currentEl: root.querySelector('[data-pdp-slider-current]'),
        prev: root.querySelector('[data-pdp-slider-prev]'),
        next: root.querySelector('[data-pdp-slider-next]'),
      });
      setupSlider(dSlider, {
        currentEl: root.querySelector('[data-pdp-d-current]'),
        prev: root.querySelector('[data-pdp-d-prev]'),
        next: root.querySelector('[data-pdp-d-next]'),
        thumbs: Array.from(root.querySelectorAll('[data-pdp-d-thumb]')),
      });

      // ----- Autoplay gallery videos when scrolled into view -----
      // Videos are muted + playsinline so browsers allow programmatic play.
      // The observer clips against the horizontal snap slider, so a video only
      // plays while its slide is the visible one AND in the vertical viewport.
      const galleryVideos = root.querySelectorAll('[data-pdp-video]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (galleryVideos.length && !reduceMotion && 'IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              const played = video.play();
              if (played && played.catch) played.catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.5, 1] });
        galleryVideos.forEach((video) => videoObserver.observe(video));
      }

      // Scroll both galleries to the slide whose image matches `url`.
      function showImage(url) {
        if (!url) return;
        [mSlider, dSlider].forEach((slider) => {
          if (!slider) return;
          const slides = slider.querySelectorAll('[data-full]');
          for (let i = 0; i < slides.length; i++) {
            if (slides[i].dataset.full === url) { scrollSliderTo(slider, i); break; }
          }
        });
      }

      // ----- Variant selection -----
      const variantSelect = form.querySelector('[data-pdp-variant-id]');
      const optionInputs = form.querySelectorAll('[data-pdp-option]');
      const submit = form.querySelector('[data-pdp-submit]');
      const submitLabel = form.querySelector('[data-pdp-submit-label]');
      const priceEl = root.querySelector('[data-pdp-price]');
      const availabilityEl = root.querySelector('[data-pdp-availability]');
      const stockDotEl = root.querySelector('[data-pdp-stock-dot]');

      const strings = {
        addToCart: form.dataset.stringAddToCart || 'Add to basket',
        soldOut: form.dataset.stringSoldOut || 'Sold out',
        unavailable: form.dataset.stringUnavailable || 'Unavailable',
      };

      // Stock-state → dot colour + label. Mirrors the Liquid render above.
      // Labels come from data-* attributes because Liquid is not evaluated inside {% javascript %}.
      const STOCK_DOT_CLASSES = ['bg-green-500', 'bg-orange-500', 'bg-red-500'];
      const stockStates = {
        in_stock: { dot: 'bg-green-500', label: form.dataset.stringInStock || 'In stock' },
        low_stock: { dot: 'bg-orange-500', label: form.dataset.stringLowStock || 'Low stock' },
        pre_order: { dot: 'bg-orange-500', label: form.dataset.stringPreOrder || 'Pre-order' },
        out_of_stock: { dot: 'bg-red-500', label: strings.soldOut },
      };
      const applyStockState = (state) => {
        const info = stockStates[state] || stockStates.in_stock;
        if (stockDotEl) {
          stockDotEl.classList.remove(...STOCK_DOT_CLASSES);
          stockDotEl.classList.add(info.dot);
        }
        if (availabilityEl) availabilityEl.textContent = info.label;
      };

      if (variantSelect) {
        const selectedOptions = () => {
          const byIndex = {};
          optionInputs.forEach((input) => {
            if (input.checked) byIndex[input.dataset.optionIndex] = input.value;
          });
          const out = [];
          for (let i = 0; byIndex[i] !== undefined; i++) out.push(byIndex[i]);
          return out;
        };

        const announceVariant = (matched, available) => {
          if (history.replaceState) {
            try {
              const url = new URL(window.location.href);
              url.searchParams.set('variant', matched.value);
              history.replaceState(history.state, '', url.toString());
            } catch (e) {}
          }
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          document.dispatchEvent(
            new CustomEvent('variant:change', {
              bubbles: true,
              detail: {
                variant: {
                  id: Number(matched.value),
                  available: available,
                  title: matched.dataset.variantOptions || '',
                },
              },
            })
          );
        };

        const update = () => {
          const target = selectedOptions().join(' / ');
          let matched = null;
          variantSelect.querySelectorAll('option').forEach((opt) => {
            if (opt.dataset.variantOptions === target) matched = opt;
          });

          if (!matched) {
            submit.disabled = true;
            submitLabel.textContent = strings.unavailable;
            return;
          }

          variantSelect.value = matched.value;
          const available = matched.dataset.variantAvailable === 'true';
          submit.disabled = !available;
          submitLabel.textContent = available ? strings.addToCart : strings.soldOut;
          announceVariant(matched, available);

          if (priceEl) {
            const price = matched.dataset.variantPrice;
            const compare = matched.dataset.variantCompareAtPrice;
            const discount = matched.dataset.variantDiscount;
            priceEl.innerHTML = compare
              ? '<span class="font-semibold text-(--color-fg)">' + price + '</span>' +
                '<span class="inline-flex h-[18px] w-[50px] items-center justify-center bg-[#E6CAD0] font-sans text-[12px] font-medium leading-[20px] tracking-[-0.03em] text-[#450E22]">-' + discount + '%</span>' +
                '<span class="font-sans text-[14px] font-normal leading-[22px] tracking-[-0.03em] text-[#777777] line-through">' + compare + '</span>'
              : '<span class="font-semibold text-(--color-fg)">' + price + '</span>';
          }
          applyStockState(matched.dataset.variantStockState);
          if (matched.dataset.variantImage) {
            showImage(matched.dataset.variantImage);
          }
          // Keep the wishlist buttons' Swym variant id (epi) in sync with the selection.
          root.querySelectorAll('[data-pdp-wishlist]').forEach((b) => { b.dataset.variantId = matched.value; });
          updateUnderlayForVariant(matched);
          updateUrgencyNoteForVariant(matched);
        };

        optionInputs.forEach((input) => input.addEventListener('change', update));
      }

      // ----- Size unit toggle (cm / ft) -----
      const unitToggle = form.querySelector('[data-size-unit-toggle]');
      if (unitToggle) {
        const unitButtons = unitToggle.querySelectorAll('[data-size-unit]');
        const sizeLabels = form.querySelectorAll('[data-size-display]');

        const cmToFt = (str) => {
          if (!/cm/i.test(str)) return str;
          return str
            .replace(/cm/gi, '')
            .replace(/\d+(?:\.\d+)?/g, (n) => {
              const inches = parseFloat(n) / 2.54;
              let ft = Math.floor(inches / 12);
              let inch = Math.round(inches - ft * 12);
              if (inch === 12) { ft += 1; inch = 0; }
              return inch ? ft + "'" + inch + '"' : ft + "'";
            })
            .replace(/\s+/g, ' ')
            .trim();
        };

        const applyUnit = (unit) => {
          sizeLabels.forEach((el) => {
            const cm = el.dataset.sizeCm;
            el.textContent = unit === 'ft' ? cmToFt(cm) : cm;
          });
          unitButtons.forEach((btn) => {
            const active = btn.dataset.sizeUnit === unit;
            if (active) btn.dataset.active = '';
            else delete btn.dataset.active;
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        };

        unitButtons.forEach((btn) => btn.addEventListener('click', () => applyUnit(btn.dataset.sizeUnit)));
      }

      // ----- Dispatch countdown -----
      const dispatches = form.querySelectorAll('[data-pdp-dispatch]');
      if (dispatches.length) {
        const cutoffHour = parseInt(dispatches[0].dataset.cutoffHour, 10) || 16;
        const dispatchDays = parseInt(dispatches[0].dataset.dispatchDays, 10) || 1;
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        const ordinal = (n) => {
          const s = ['th', 'st', 'nd', 'rd'];
          const v = n % 100;
          return n + (s[(v - 20) % 10] || s[v] || s[0]);
        };

        // The cutoff is a WAREHOUSE time, not a shopper-local one. Using the browser
        // clock meant a CET shopper (FR/DE/ES) saw the countdown an hour out and was
        // promised a dispatch date the warehouse could not hit. Resolve "now" in the
        // warehouse timezone so every market counts down to the same real instant.
        const WAREHOUSE_TZ = 'Europe/London';
        const warehouseNow = () => {
          try {
            return new Date(new Date().toLocaleString('en-US', { timeZone: WAREHOUSE_TZ }));
          } catch (e) {
            return new Date();
          }
        };

        const tick = () => {
          const now = warehouseNow();
          const cutoff = new Date(now);
          cutoff.setHours(cutoffHour, 0, 0, 0);

          let offset = dispatchDays;
          if (now > cutoff) {
            cutoff.setDate(cutoff.getDate() + 1);
            offset += 1;
          }

          const diff = cutoff - now;
          const h = Math.floor(diff / 3600000);
          const m = Math.floor((diff % 3600000) / 60000);
          const countdownText = h + ' hr ' + m + ' mins';

          const dispatchDate = new Date(now);
          dispatchDate.setDate(dispatchDate.getDate() + offset);
          const dateText = days[dispatchDate.getDay()] + ' ' + ordinal(dispatchDate.getDate()) + ' ' + months[dispatchDate.getMonth()];

          dispatches.forEach((dispatch) => {
            const countdownEl = dispatch.querySelector('[data-pdp-countdown]');
            const dateEl = dispatch.querySelector('[data-pdp-dispatch-date]');
            if (countdownEl) countdownEl.textContent = countdownText;
            if (dateEl) dateEl.textContent = dateText;
          });
        };

        tick();
        setInterval(tick, 60000);
      }

      // ----- Anti-slip underlay (deferred — committed with the rug) -----
      // Selecting the underlay does NOT touch the cart; it only records intent.
      // The underlay line is created when the rug is added to the cart
      // (`commitUnderlay`, called from the submit handler below). It can be
      // removed before the rug is added (just deselects) or after (also drops
      // the committed cart line). Switching the size selector only changes what's
      // displayed — it never mutates the cart, because a committed underlay stays
      // attached to whichever rug is actually in the cart (re-pointing it onto a
      // not-yet-added size would strand it with no parent). `updateUnderlayForVariant`
      // is a hoisted declaration so the variant `update()` above can call it.
      const antislipCard = root.querySelector('[data-antislip-card]');
      const antislipButton = antislipCard && antislipCard.querySelector('[data-antislip-add]');
      const antislipAddedGroup = antislipCard && antislipCard.querySelector('[data-antislip-added]');
      const antislipRemove = antislipCard && antislipCard.querySelector('[data-antislip-remove]');
      const antislipImage = antislipCard && antislipCard.querySelector('[data-antislip-image]');
      const antislipPrice = antislipCard && antislipCard.querySelector('[data-antislip-price]');
      const antislipNote = root.querySelector('[data-antislip-note]');

      // The note under the underlay card is not part of the underlay: it carries the
      // "Outlet" discount notice or the product/variant urgency message, already
      // resolved per variant in Liquid onto each <option>. Hoisted so the variant
      // `update()` above can call it.
      function updateUrgencyNoteForVariant(matched) {
        if (!antislipNote) return;
        const message = matched.dataset.urgencyMessage || '';
        antislipNote.textContent = message;
        antislipNote.hidden = !message;
      }
      // `key` is the committed cart line — empty until the rug is added (or if
      // it was never in the cart). `parentVariantId` is the rug variant that line
      // is attached to, so we can tell when the displayed size is the committed one.
      const antislipState = {
        key: antislipCard ? antislipCard.dataset.underlayKey || '' : '',
        variantId: antislipButton ? antislipButton.dataset.variantId || '' : '',
        parentVariantId:
          antislipCard && antislipCard.dataset.underlayKey ? antislipCard.dataset.parentVariantId || '' : '',
      };
      // Selected = the customer wants the underlay. Already-in-cart ⇒ selected.
      let antislipSelected = !!antislipState.key;

      // Toggles between the "Add" pill and the "Remove" group (matches the cart card).
      function setAntislipAdded(isAdded) {
        const flag = isAdded ? 'true' : 'false';
        if (antislipButton) antislipButton.dataset.added = flag;
        if (antislipAddedGroup) antislipAddedGroup.dataset.added = flag;
        if (antislipCard) antislipCard.dataset.added = flag;
      }
      setAntislipAdded(antislipSelected);

      function updateUnderlayForVariant(matched) {
        if (!antislipCard) return;
        const id = matched.dataset.underlayId || '';
        const parentVariantId = matched.value;
        antislipCard.dataset.parentVariantId = parentVariantId;
        antislipCard.hidden = !id;

        if (id) {
          if (antislipButton) {
            antislipButton.dataset.variantId = id;
            antislipButton.disabled = matched.dataset.underlayAvailable === 'false';
          }
          if (antislipImage) {
            const img = matched.dataset.underlayImage || '';
            if (img) { antislipImage.src = img; antislipImage.hidden = false; }
            else { antislipImage.removeAttribute('src'); antislipImage.hidden = true; }
          }
          if (antislipPrice && matched.dataset.underlayPrice) {
            antislipPrice.textContent = matched.dataset.underlayPrice;
          }
        }

        // Switching the size selector never mutates the cart. Show "added" for
        // the size whose underlay is actually committed; for any other size,
        // reflect the customer's opt-in for the underlay they'd add with it.
        const committedHere =
          !!antislipState.key && String(antislipState.parentVariantId) === String(parentVariantId);
        setAntislipAdded(committedHere || antislipSelected);
      }

      // Select only — nothing is added until the rug is added to the cart.
      if (antislipButton) {
        antislipButton.addEventListener('click', () => {
          antislipSelected = true;
          setAntislipAdded(true);
        });
      }

      // Remove works before the rug is added (deselect) or after (also drops the
      // committed cart line). Only touch the cart when the displayed size is the
      // committed one — otherwise we'd drop another rug's underlay.
      if (antislipRemove) {
        antislipRemove.addEventListener('click', async () => {
          antislipSelected = false;
          setAntislipAdded(false);
          const committedHere =
            !!antislipState.key &&
            String(antislipState.parentVariantId) === String(antislipCard.dataset.parentVariantId);
          if (!committedHere || !window.UnderlayCart) return;
          antislipRemove.disabled = true;
          try {
            await window.UnderlayCart.updateLines({ [antislipState.key]: 0 });
            antislipState.key = '';
            antislipState.variantId = '';
            antislipState.parentVariantId = '';
            window.UnderlayCart.refresh(false);
          } catch (e) {
            // Leave the line; the customer can retry.
          } finally {
            antislipRemove.disabled = false;
          }
        });
      }

      // Commit the selected underlay to the cart, linked to the just-added rug.
      async function commitUnderlay(parentVariantId) {
        if (!antislipCard || !window.UnderlayCart || !parentVariantId) return;
        const underlayId = antislipButton && antislipButton.dataset.variantId;
        if (!antislipSelected || !underlayId || (antislipButton && antislipButton.disabled)) return;
        let cart;
        try { cart = await window.UnderlayCart.getCart(); } catch (e) { return; }
        const existing = cart.items.find(
          (it) => it.properties && String(it.properties._underlay_for) === String(parentVariantId)
        );
        if (existing) {
          antislipState.key = existing.key;
          antislipState.variantId = underlayId;
          antislipState.parentVariantId = String(parentVariantId);
          return;
        }
        try {
          const line = await window.UnderlayCart.addUnderlay(underlayId, parentVariantId, 1);
          antislipState.key = (line && line.key) || '';
          antislipState.variantId = underlayId;
          antislipState.parentVariantId = String(parentVariantId);
          await window.UnderlayCart.reconcile();
        } catch (e) {
          // Non-fatal: the rug is already in the cart.
        }
      }

      // ----- Add to basket → AJAX add, then open the cart drawer -----
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submitBtn = e.submitter || form.querySelector('[data-pdp-submit]');
        const label = submitBtn && submitBtn.querySelector('[data-pdp-submit-label]');
        const original = label ? label.textContent : null;
        if (submitBtn) submitBtn.disabled = true;

        try {
          const res = await fetch(pdpCartRoute('cart_add_url', '/cart/add'), {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          if (!res.ok) throw new Error('Add to cart failed');
          // Add the selected anti-slip underlay together with the rug.
          const idInput = form.querySelector('[name="id"]');
          await commitUnderlay(
            idInput ? String(idInput.value) : antislipCard && antislipCard.dataset.parentVariantId
          );
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
          );
        } catch (err) {
          // Fall back to a full navigation so the customer is never stuck.
          form.submit();
          return;
        } finally {
          if (submitBtn) submitBtn.disabled = false;
          if (label && original !== null) label.textContent = original;
        }
      });

      // ----- Tab switching (Rugs / Runners / Cushions) -----
      const tabs = root.querySelectorAll('[data-pdp-tab]');
      const panels = root.querySelectorAll('[data-pdp-tab-panel]');
      const footers = root.querySelectorAll('[data-pdp-footer]');
      const scrollArea = root.querySelector('[data-pdp-scroll]');
      if (tabs.length && panels.length) {
        const activate = (target) => {
          tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.pdpTabTarget === target ? 'true' : 'false'));
          panels.forEach((p) => { p.hidden = p.dataset.pdpTabPanel !== target; });
          const desired = target === 'cushions' || target === 'runner' ? target : 'product';
          const footerTarget = root.querySelector('[data-pdp-footer="' + desired + '"]') ? desired : 'product';
          footers.forEach((f) => { f.hidden = f.dataset.pdpFooter !== footerTarget; });
          if (scrollArea) scrollArea.scrollTop = 0;
        };
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => activate(tab.dataset.pdpTabTarget));
        });
        // Sync initial panel visibility with whichever tab is marked active.
        const initial = root.querySelector('[data-pdp-tab][aria-selected="true"]') || tabs[0];
        if (initial) activate(initial.dataset.pdpTabTarget);

        // Mobile "complete your room" promo → open the Cushions tab and scroll to it.
        const cushionsTab = root.querySelector('[data-pdp-tab][data-pdp-tab-target="cushions"]');
        if (cushionsTab) {
          root.querySelectorAll('[data-room-promo-cushions]').forEach((btn) => {
            btn.addEventListener('click', () => {
              activate('cushions');
              cushionsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          });
        }
      }

      // ----- Cushions "complete your room" selector + bundle banner -----
      const cushions = root.querySelector('[data-cushions]');
      if (cushions) {
        const tiers = cushions.querySelectorAll('[data-cushions-tier]');
        const savingCells = cushions.querySelectorAll('[data-cushions-saving]');
        const steppers = cushions.querySelectorAll('[data-cushions-stepper]');
        const bundleBtns = cushions.querySelectorAll('[data-cushions-bundle]');
        const fill = cushions.querySelector('[data-cushions-fill]');
        const productId = cushions.dataset.productId;
        // A Liquid-rendered `{{ 111111 | money }}` sample — see formatMoney below.
        const moneySample = cushions.dataset.moneySample || '1,111.11';
        const footerQtyEl = root.querySelector('[data-cushions-footer-qty]');
        const addBtn = root.querySelector('[data-cushions-add]');
        const totalEl = root.querySelector('[data-cushions-total]');
        const saveBadgeEl = root.querySelector('[data-cushions-savebadge]');
        const compareEl = root.querySelector('[data-cushions-compare]');
        const hintEl = root.querySelector('[data-cushions-hint]');
        const hintMoreEl = root.querySelector('[data-cushions-hint-more]');
        const hintSaveEl = root.querySelector('[data-cushions-hint-save]');
        const maxTier = tiers.length;
        const BUNDLE_PROP = '_bundle_for';

        const totalQty = () => {
          let n = 0;
          steppers.forEach((s) => { n += parseInt(s.dataset.qty, 10) || 0; });
          return n;
        };

        // Presentment money formatter. The shape (symbol position, separators, number
        // of decimals) is read from a real `{{ 111111 | money }}` sample rendered by
        // Liquid, so the JS-computed bundle total is byte-identical in style to the
        // static prices beside it in every market.
        //
        // This previously ran off shop.money_format, which is the SHOP's format (GBP)
        // regardless of market — so a euro shopper saw a correct euro amount rendered
        // as "£58.00" the moment they touched a stepper.
        const formatMoney = (() => {
          const shape = { prefix: '', suffix: '', thousands: ',', decimal: '.', places: 2 };
          const sample = String(moneySample).replace(/<[^>]*>/g, '');
          const match = sample.match(/\d[\d\s.,' ]*\d|\d/);
          if (match) {
            const numeric = match[0];
            shape.prefix = sample.slice(0, match.index);
            shape.suffix = sample.slice(match.index + numeric.length);
            const groups = numeric.split(/[^\d]/);
            const seps = numeric.match(/[^\d]/g) || [];
            if (groups.length > 1 && groups[groups.length - 1].length === 2) {
              // Sample is 1111.11, so a 2-digit final group means decimals are shown.
              shape.places = 2;
              shape.decimal = seps[seps.length - 1];
              shape.thousands = seps.length > 1 ? seps[0] : '';
            } else {
              shape.places = 0;
              shape.thousands = seps.length ? seps[0] : '';
            }
          }
          return (cents) => {
            const fixed = (Math.round(cents) / 100).toFixed(shape.places);
            const parts = fixed.split('.');
            const whole = shape.thousands
              ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, shape.thousands)
              : parts[0];
            return shape.prefix + whole + (parts[1] ? shape.decimal + parts[1] : '') + shape.suffix;
          };
        })();

        // Sum the selected cushions' price + compare-at total (in cents).
        const computeTotals = () => {
          let total = 0;
          let compare = 0;
          steppers.forEach((s) => {
            const q = parseInt(s.dataset.qty, 10) || 0;
            if (!q) return;
            const price = parseInt(s.dataset.priceCents, 10) || 0;
            const comp = parseInt(s.dataset.compareCents, 10) || price;
            total += price * q;
            compare += comp * q;
          });
          return { total, compare };
        };

        // Show/hide an element while preserving its intended display when shown.
        const toggleEl = (el, show, display) => {
          if (!el) return;
          el.classList.toggle('hidden', !show);
          el.classList.toggle(display, show);
        };

        // Footer price row: live total, % saved + struck compare-at (when discounted).
        const updateFooterPricing = () => {
          const { total, compare } = computeTotals();
          if (totalEl) totalEl.textContent = formatMoney(total);
          const hasSaving = compare > total;
          toggleEl(saveBadgeEl, hasSaving, 'inline-flex');
          if (hasSaving && saveBadgeEl) saveBadgeEl.textContent = '-' + Math.round(((compare - total) / compare) * 100) + '%';
          toggleEl(compareEl, hasSaving, 'inline');
          if (hasSaving && compareEl) compareEl.textContent = formatMoney(compare);
        };

        // Footer hint: "Add N more to save XX" — drives toward the 5+ tier, hides at 5+.
        const updateHint = () => {
          const tq = totalQty();
          const remaining = maxTier - tq;
          const show = tq > 0 && remaining > 0;
          toggleEl(hintEl, show, 'flex');
          if (show) {
            if (hintMoreEl) hintMoreEl.textContent = remaining;
            if (hintSaveEl) {
              const topCell = cushions.querySelector('[data-cushions-saving][data-qty="' + maxTier + '"]');
              hintSaveEl.textContent = topCell ? topCell.textContent.trim() : '';
            }
          }
        };

        // Green-fill the quantity tiers up to the running total (from the bundle
        // banner or any manual stepper) and stretch the connecting bar to match.
        const refreshTiers = () => {
          const total = totalQty();
          const active = Math.min(total, maxTier);
          tiers.forEach((el) => {
            const on = total > 0 && (parseInt(el.dataset.qty, 10) || 0) <= active;
            el.classList.toggle('bg-[#3E8E5A]', on);
            el.classList.toggle('bg-(--color-fg)', !on);
          });
          savingCells.forEach((el) => {
            const on = total > 0 && (parseInt(el.dataset.qty, 10) || 0) <= active;
            el.classList.toggle('text-(--color-fg)', on);
            el.classList.toggle('text-(--color-muted)', !on);
          });
          if (fill) fill.style.width = (active > 1 ? (active - 1) * 20 : 0) + '%';
          if (footerQtyEl) footerQtyEl.textContent = total;
          if (addBtn) addBtn.disabled = total === 0;
          updateFooterPricing();
          updateHint();
        };

        // Reflect a stepper's qty into its own controls (count text, dec visibility).
        const syncStepper = (stepper) => {
          const q = parseInt(stepper.dataset.qty, 10) || 0;
          const count = stepper.querySelector('[data-cushions-count]');
          const dec = stepper.querySelector('[data-cushions-dec]');
          if (count) {
            count.textContent = q;
            count.classList.toggle('hidden', q === 0);
          }
          if (dec) {
            dec.classList.toggle('hidden', q === 0);
            dec.classList.toggle('inline-flex', q > 0);
          }
        };

        const setQty = (stepper, q) => {
          stepper.dataset.qty = String(Math.max(0, q));
          syncStepper(stepper);
        };

        // The bundle is "added" only when every real bundle product has a quantity.
        const realSteppers = () => Array.from(steppers).filter((s) => s.dataset.variantId);
        const refreshBundleState = () => {
          if (!bundleBtns.length) return;
          const real = realSteppers();
          const added = real.length > 0 && real.every((s) => (parseInt(s.dataset.qty, 10) || 0) > 0);
          bundleBtns.forEach((b) => b.setAttribute('aria-pressed', added ? 'true' : 'false'));
        };

        steppers.forEach((stepper) => {
          const inc = stepper.querySelector('[data-cushions-inc]');
          const dec = stepper.querySelector('[data-cushions-dec]');
          if (inc) inc.addEventListener('click', () => {
            setQty(stepper, (parseInt(stepper.dataset.qty, 10) || 0) + 1);
            refreshTiers();
            refreshBundleState();
          });
          if (dec) dec.addEventListener('click', () => {
            setQty(stepper, (parseInt(stepper.dataset.qty, 10) || 0) - 1);
            refreshTiers();
            refreshBundleState();
          });
        });

        // Variant <select> on a card → update its displayed price + tracked variant id.
        cushions.querySelectorAll('[data-cushions-variant]').forEach((sel) => {
          sel.addEventListener('change', () => {
            const opt = sel.options[sel.selectedIndex];
            const card = sel.closest('[data-cushions-card]');
            if (!card || !opt) return;
            const priceEl = card.querySelector('[data-cushions-price]');
            const stepper = card.querySelector('[data-cushions-stepper]');
            if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
            if (stepper) {
              if (opt.value) stepper.dataset.variantId = opt.value;
              if (opt.dataset.priceCents) stepper.dataset.priceCents = opt.dataset.priceCents;
              if (opt.dataset.compareCents) stepper.dataset.compareCents = opt.dataset.compareCents;
            }
            updateFooterPricing();
          });
        });

        // Bundle card ADD → add (or toggle off) every product in the bundle at once.
        // All repeated bundle cards share one selection, so any card's button drives
        // (and reflects) the same state.
        bundleBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const added = btn.getAttribute('aria-pressed') !== 'true';
            bundleBtns.forEach((b) => b.setAttribute('aria-pressed', added ? 'true' : 'false'));
            steppers.forEach((s) => setQty(s, added ? 1 : 0));
            refreshTiers();
          });
        });

        // Footer "Add to basket" → replace this product's bundle lines in the cart
        // with the current selection (so re-adding never duplicates), then open the
        // drawer. Each line carries `_bundle_for: <product id>` so we can find them
        // again on return.
        if (addBtn) {
          const addLabel = addBtn.textContent.trim();
          addBtn.addEventListener('click', async () => {
            const items = [];
            steppers.forEach((s) => {
              const q = parseInt(s.dataset.qty, 10) || 0;
              const id = s.dataset.variantId;
              if (q > 0 && id) items.push({ id: Number(id), quantity: q, properties: { [BUNDLE_PROP]: String(productId) } });
            });
            if (!items.length) {
              console.warn('[cushions] Add to basket: no cushion has a quantity + variant id to add.', { steppers: steppers.length });
              addBtn.textContent = 'Select a cushion first';
              setTimeout(() => { addBtn.textContent = addLabel; }, 1800);
              return;
            }
            addBtn.disabled = true;
            addBtn.textContent = 'Adding…';
            try {
              const cart = await fetch(pdpCartRoute('cart_url', '/cart'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
              const updates = {};
              (cart.items || []).forEach((it) => {
                if (it.properties && String(it.properties[BUNDLE_PROP]) === String(productId)) updates[it.key] = 0;
              });
              if (Object.keys(updates).length) {
                const upd = await fetch(pdpCartRoute('cart_update_url', '/cart/update'), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ updates }),
                });
                if (!upd.ok) throw new Error('cart update failed (' + upd.status + ')');
              }
              const res = await fetch(pdpCartRoute('cart_add_url', '/cart/add'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items }),
              });
              if (!res.ok) {
                let detail = res.status + '';
                try { const j = await res.json(); detail = j.description || j.message || detail; } catch (e) {}
                throw new Error('cart add failed: ' + detail);
              }
              addBtn.textContent = addLabel;
              document.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
              );
            } catch (err) {
              // Surface the failure instead of silently doing nothing.
              console.error('[cushions] Add to basket failed:', err, { items });
              addBtn.textContent = 'Couldn’t add — try again';
              setTimeout(() => { addBtn.textContent = addLabel; }, 2200);
            } finally {
              addBtn.disabled = totalQty() === 0;
            }
          });
        }

        // Restore selection on return: if this product's bundle lines are already in
        // the cart, reflect their quantities (and chosen variants) in the steppers.
        const restoreFromCart = async () => {
          if (!productId) return;
          try {
            const cart = await fetch(pdpCartRoute('cart_url', '/cart'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
            const qtyByVariant = {};
            (cart.items || []).forEach((it) => {
              if (it.properties && String(it.properties[BUNDLE_PROP]) === String(productId)) {
                qtyByVariant[it.variant_id] = (qtyByVariant[it.variant_id] || 0) + it.quantity;
              }
            });
            if (!Object.keys(qtyByVariant).length) return;
            cushions.querySelectorAll('[data-cushions-card]').forEach((card) => {
              const stepper = card.querySelector('[data-cushions-stepper]');
              if (!stepper) return;
              const sel = card.querySelector('[data-cushions-variant]');
              const candidates = [];
              if (stepper.dataset.variantId) candidates.push(stepper.dataset.variantId);
              if (sel) Array.from(sel.options).forEach((o) => candidates.push(o.value));
              const match = candidates.find((id) => qtyByVariant[id]);
              if (!match) return;
              stepper.dataset.variantId = match;
              if (sel) {
                sel.value = match;
                const opt = sel.options[sel.selectedIndex];
                const priceEl = card.querySelector('[data-cushions-price]');
                if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
              }
              setQty(stepper, qtyByVariant[match]);
            });
            refreshTiers();
            refreshBundleState();
          } catch (err) {
            // Non-fatal — the panel just starts empty.
          }
        };

        refreshTiers();
        restoreFromCart();
      }
    });
  })();

  // ----- Sticky details panel (desktop) -----
  // The right column locks its bottom to the bottom of the viewport as you
  // scroll past it. Pure CSS `position: sticky; bottom: 0` can't do this here:
  // the panel lives in a grid cell whose height is driven by the (taller) media
  // column, and bottom-sticky never engages while scrolling *down* a short
  // panel. So we translate the panel in flow instead — no layout shift, correct
  // width/position — clamped between its natural top and the bottom of its
  // column so it never floats above its start or spills past the section.
  (function setupPDPStickyPanel() {
    const mq = window.matchMedia('(min-width: 64rem)');
    const panel = document.querySelector('[data-pdp-sticky]');
    const wrapper = document.querySelector('[data-pdp-panel]');
    if (!panel || !wrapper) return;

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
    let ticking = false;
    // Cache the layout metrics that don't change while scrolling. They are only
    // re-read on layout changes (resize / ResizeObserver / breakpoint), so the
    // per-frame scroll path never touches layout-reading properties.
    let metrics = null; // { panelHeight, room, containerTop, viewportH }

    function measure() {
      if (!mq.matches) {
        metrics = null;
        panel.style.transform = '';
        return;
      }
      const panelHeight = panel.offsetHeight;
      metrics = {
        panelHeight: panelHeight,
        room: wrapper.offsetHeight - panelHeight, // how far the panel can travel
        containerTop: wrapper.getBoundingClientRect().top + window.scrollY, // absolute (scroll-invariant)
        viewportH: window.innerHeight,
      };
      position();
    }

    function position() {
      ticking = false;
      if (!metrics) return; // mobile / not yet measured
      if (metrics.room <= 0) {
        // Panel is as tall as (or taller than) its column — nothing to scroll past.
        panel.style.transform = '';
        return;
      }
      const offset = clamp(
        window.scrollY + metrics.viewportH - metrics.panelHeight - metrics.containerTop,
        0,
        metrics.room
      );
      panel.style.transform = `translateY(${offset}px)`;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(position);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(measure);
      ro.observe(panel);
      ro.observe(wrapper);
    }
    if (mq.addEventListener) mq.addEventListener('change', measure);
    measure();
  })();

  // ----- Price-area review stars → scroll to the reviews section -----
  // The reviews block is a separate section, so the anchor id is generated on it
  // (data-reviews-target) and matched here at runtime — nothing is hard-coded.
  (function reviewsScrollLink() {
    const findTarget = () => document.querySelector('[data-reviews-target]');

    // Keep the anchor's href pointing at the generated id (for accessibility /
    // open-in-new-tab), re-checking in case the reviews section renders later.
    const syncHref = () => {
      const target = findTarget();
      if (!target || !target.id) return;
      document.querySelectorAll('[data-pdp-reviews-link]').forEach((a) => {
        a.setAttribute('href', '#' + target.id);
      });
    };
    syncHref();

    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-pdp-reviews-link]');
      if (!link) return;
      const target = findTarget();
      if (!target) return; // no reviews section on this page — leave default behaviour
      e.preventDefault();
      // Scrolling to the (always-present) target triggers a deferred section to
      // render as it enters the viewport; scroll-mt on the target offsets the
      // sticky header.
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (target.id && history.replaceState) history.replaceState(null, '', '#' + target.id);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function setupSearchPageTabs() {
    const tabs = document.querySelectorAll('[data-search-page-tab]');
    const panels = document.querySelectorAll('[data-search-page-panel]');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-search-page-tab');
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((p) => {
          p.classList.toggle('hidden', p.getAttribute('data-search-page-panel') !== target);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-slider"] && !Shopify.designMode) return;
  try {
    
  class ProductTabSlider extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab));
      });
      const prev = this.querySelector('[data-slider-prev]');
      const next = this.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => this.scroll(-1));
      if (next) next.addEventListener('click', () => this.scroll(1));
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.dataset.panel !== id);
      });
      this.dataset.activeTab = id;
    }

    scroll(direction) {
      const panel = this.panels.find((p) => !p.classList.contains('hidden'));
      if (!panel) return;
      const scroller = panel.querySelector('[data-scroller]');
      if (!scroller) return;
      const amount = scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
  }
  customElements.define('product-tab-slider', ProductTabSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  (function setupSizeGuide() {
    const root = document.querySelector('size-guide');
    if (!root) return;

    const panel = root.querySelector('[data-size-guide]');
    const overlay = root.querySelector('[data-size-guide-overlay]');
    const closers = root.querySelectorAll('[data-size-guide-close]');
    const tabs = root.querySelectorAll('[data-size-guide-tab]');
    const panels = root.querySelectorAll('[data-size-guide-panel]');
    let lastFocus = null;
    let closeTimer = null;

    // The drawer lives off-screen (transform), so its images/video posters must
    // not fetch on page load. Load them the first time it opens.
    const loadDrawerMedia = () => {
      root.querySelectorAll('img[data-sg-lazy]').forEach((img) => {
        if (img.dataset.sizes) img.sizes = img.dataset.sizes;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.removeAttribute('data-sg-lazy');
      });
      root.querySelectorAll('[data-sg-video-poster]').forEach((wrap) => {
        const video = wrap.querySelector('video');
        if (video && !video.getAttribute('poster')) video.setAttribute('poster', wrap.dataset.sgVideoPoster);
      });
    };

    const open = (trigger) => {
      lastFocus = trigger || document.activeElement;
      window.clearTimeout(closeTimer);
      loadDrawerMedia();
      panel.hidden = false;
      requestAnimationFrame(() => {
        panel.dataset.active = '';
        overlay.dataset.active = '';
        panel.focus();
      });
      document.documentElement.style.overflow = 'hidden';
    };

    const close = () => {
      delete panel.dataset.active;
      delete overlay.dataset.active;
      document.documentElement.style.overflow = '';
      closeTimer = window.setTimeout(() => {
        panel.hidden = true;
      }, 300);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    };

    document.querySelectorAll('[data-size-guide-open]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        open(el);
      });
    });

    closers.forEach((el) => el.addEventListener('click', close));
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.dataset.active !== undefined) close();
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-size-guide-tab');
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((p) => {
          p.classList.toggle('hidden', p.getAttribute('data-size-guide-panel') !== target);
        });
      });
    });

    /* Click-and-drag horizontal scrolling for the tab strip */
    const tablist = root.querySelector('[data-size-guide-tablist]');
    if (tablist) {
      let down = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;

      tablist.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) return;
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = tablist.scrollLeft;
      });

      tablist.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          moved = true;
          tablist.dataset.dragging = '';
          tablist.setPointerCapture(e.pointerId);
        }
        if (moved) tablist.scrollLeft = startScroll - dx;
      });

      const end = () => {
        down = false;
        delete tablist.dataset.dragging;
      };
      tablist.addEventListener('pointerup', end);
      tablist.addEventListener('pointercancel', end);

      /* Swallow the click that fires after a drag so it doesn't switch tabs */
      tablist.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    }

    /* Slide pagination (smaller / larger) within each panel */
    panels.forEach((p) => {
      const slides = p.querySelectorAll('[data-size-guide-slide]');
      if (slides.length < 2) return;
      const prev = p.querySelector('[data-size-guide-prev]');
      const next = p.querySelector('[data-size-guide-next]');
      let idx = 0;
      slides.forEach((s, i) => { if (s.hasAttribute('data-size-guide-default')) idx = i; });

      const update = () => {
        slides.forEach((s, i) => s.classList.toggle('hidden', i !== idx));
        if (prev) prev.disabled = idx === 0;
        if (next) next.disabled = idx === slides.length - 1;
      };
      if (prev) prev.addEventListener('click', () => { if (idx > 0) { idx -= 1; update(); } });
      if (next) next.addEventListener('click', () => { if (idx < slides.length - 1) { idx += 1; update(); } });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["small-card-slider"] && !Shopify.designMode) return;
  try {
    
  class SmallCardSlider extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab));
      });
      const prev = this.querySelector('[data-slider-prev]');
      const next = this.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => this.scroll(-1));
      if (next) next.addEventListener('click', () => this.scroll(1));
      // Card images are JS-lazy (data-lazy-img); the shared loader in global.js
      // swaps them in as they scroll into view.
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.dataset.panel !== id);
      });
      this.dataset.activeTab = id;
    }

    scroll(direction) {
      const panel = this.panels.find((p) => !p.classList.contains('hidden'));
      if (!panel) return;
      const scroller = panel.querySelector('[data-scroller]');
      if (!scroller) return;
      const amount = scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
  }
  customElements.define('small-card-slider', SmallCardSlider);

  } catch(e) { console.error(e); }
})();
})();
